import React from "react";

/**
 * A reusable table header (<th>) component that allows sorting.
 *
 * @param {object} props
 * @param {string} props.columnKey - A unique key for the column (e.g., 'guestName').
 * @param {object} props.sortConfig - The current sorting state ({ key, direction }).
 * @param {function} props.handleSort - The function to call when the header is clicked.
 * @param {string} [props.className] - Optional additional CSS classes.
 * @param {React.ReactNode} props.children - The content of the header (e.g., "Guest Name").
 */
function SortableHeaderCell({
  children,
  columnKey,
  className = "",
  sortConfig,
  handleSort,
}) {
  const icon =
    sortConfig.key === columnKey
      ? sortConfig.direction === "ascending"
        ? "▲" // Up arrow for ascending
        : "▼" // Down arrow for descending
      : "↕"; // Default double arrow

  return (
    <th
      onClick={() => handleSort(columnKey)}
      className={`p-4 text-left cursor-pointer hover:bg-gray-100 whitespace-nowrap ${className}`}
    >
      {children} <span className="text-gray-400 ml-1">{icon}</span>
    </th>
  );
}

export default SortableHeaderCell;
